module.exports = __webpack_public_path__ + "img/thumbnail-text-with-icon-calyrafit.e3e054ac.webp";